"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quantityFromAndToRegistry = void 0;
exports.quantityFromAndToRegistry = new Map([
    ["Flow", ["VolumeFlow", "MassFlow"]],
    [
        "Humidity",
        [
            "HumidityRatio",
            "RelativeHumidity",
            "SpecificEnthalpy",
            "WetTemperature",
            "DewPointTemperature"
        ]
    ]
]);
//# sourceMappingURL=quantity-conversion-registry.js.map